import * as UrlUtilities from '../lib/UrlUtilities';

/**
 * Represents an E-Resource item, such as the NoveList Plus, K-8, and NoveList databases.
 *
 * @class EResource
 */
class EResource {
	constructor(postData, srcId) {
		this.displayName = postData.display_name;
		this.imageUrl = UrlUtilities.useLocalProtocol(postData.image_url);
		this.dbShortCode = postData.short_name;
		this.url = postData.url;
		this.srcId = srcId;
	}
}

export default EResource;



// WEBPACK FOOTER //
// ./src/models/EResource.js